var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"info",attrs:{"type":"button","aria-label":"More information","aria-haspopup":"dialog","aria-controls":"info-modal"},on:{"click":function($event){$event.preventDefault();return _vm.loadInfo.apply(null, arguments)}}},[_c('i',{staticClass:"fas fa-info",attrs:{"aria-hidden":"true"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }